var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "IQ"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Mask",
    x: 0.5,
    y: 0.5,
    width: 14,
    height: 14,
    fill: "white",
    stroke: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_808_1680",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Mask_2",
    x: 0.5,
    y: 0.5,
    width: 14,
    height: 14,
    fill: "white",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_808_1680)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5H15V0H0V5Z",
    fill: "#DF1E35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.9941H15V9.99414H0V14.9941Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 213",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 6.00781L10.7143 6.50781V9.00781H10V6.00781Z",
    fill: "#0F7A40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 213_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71387 6.00781L6.42815 6.50781V9.00781H5.71387V6.00781Z",
    fill: "#0F7A40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 213_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.57129 6.50781L9.28557 6.00781V9.00781H8.57129V6.50781Z",
    fill: "#0F7A40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 213_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.14258 7.49775L7.85686 6.99775V8.04254H8.92829V8.99775H7.85686H7.14258V7.49775Z",
    fill: "#0F7A40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 213_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28516 7.49775L4.99944 6.99775V8.04254H6.07087V8.99775H4.99944H4.28516V7.49775Z",
    fill: "#0F7A40"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIq);
export default __webpack_public_path__ + "static/media/IQ.70e1f3675a532c8b613de15dd8bd82fa.svg";
export { ForwardRef as ReactComponent };